import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexRow, NavItemBadge } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { chosenSites } from "app/common/services/chosenSites";
import { BADGE_ITEMS } from "app/components/sidebar3/types";
import { translate } from "app/filters/i18nFilter";
import { getDomainsDataFromKeys } from "app/pages/website-analysis/traffic-sources/search/overview/helpers/helpers";
import DomainCompareSelector from "app/pages/website-analysis/website-structure/pages/LineOfBusiness/components/DomainCompareSelector/DomainCompareSelector";
import { AssetsService } from "app/services/AssetsService";
import type { ISimilarInfoItem } from "app/services/sitesService/types";
import { allTrackers } from "app/services/track/track";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { DomainCompareContainer, LeftContainer, Container } from "./styledComponents";

const MAX_SIMILAR_SITES = 4;
const TitleContainer = styled(FlexRow)`
    align-items: center;
`;
const PromoteCompareBanner = () => {
    const { params } = useCurrentStateAndParams();

    const similarSites = useMemo(
        () => chosenSites.similarSitesData().slice(0, MAX_SIMILAR_SITES) as ISimilarInfoItem[],
        [],
    );

    const domainsKeysWithSimilarSites = useMemo(() => {
        const similarSitesWithKey = similarSites.map((site) => site.Domain).join(",");
        return `${params.key},${similarSitesWithKey}`;
    }, [similarSites, params.key]);

    const domainsData = getDomainsDataFromKeys(domainsKeysWithSimilarSites, similarSites);
    const keys = Object.keys(domainsData);
    const domains = keys.map((name) => ({ name, favicon: domainsData[name]?.favicon ?? null }));
    const sites = useMemo(() => domains.map((domain) => ({ name: domain.name, icon: domain.favicon })), [domains]);

    const handleCompareClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", `promote compare/${params.key}/banner`);
    };
    return (
        <Container>
            <LeftContainer>
                <FlexColumn style={{ gap: "8px" }}>
                    <TitleContainer>
                        <Text
                            fontVariant="h5_2"
                            color={colorsPalettes.carbon[500]}
                        >
                            {translate("mmx.promote.compare.banner.title")}
                        </Text>
                        <NavItemBadge type={BADGE_ITEMS.NEW} />
                    </TitleContainer>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("mmx.promote.compare.banner.subtitle")}
                    </Text>
                </FlexColumn>
                <DomainCompareSelector
                    sites={sites}
                    domainsArr={domainsKeysWithSimilarSites}
                    maxSuggestedSites={MAX_SIMILAR_SITES}
                    container={DomainCompareContainer}
                    iconName="add"
                    onClick={handleCompareClick}
                />
            </LeftContainer>
            <img
                width={321}
                src={AssetsService.assetUrl("/images/mmx/heatmaps-banner-image.png")}
                alt={"mmx_promote_compare"}
            />
        </Container>
    );
};

export default PromoteCompareBanner;
